import { Component } from '@angular/core';
import { BiMasterGridDetailsComponent } from '../bi-master-grid-details/bi-master-grid-details.component';
import { DataTypes } from 'bi-interfaces';
import { IGrid } from 'bi-interfaces/lib/interfaces/IGrid';

@Component({
  selector: 'lib-bi-master-grid-composed',
  templateUrl: '../bi-master-grid-details/bi-master-grid-details.component.html',
  styleUrls: ['../bi-master-grid-details/bi-master-grid-details.component.scss']
})
export class BiMasterGridComposedComponent extends BiMasterGridDetailsComponent implements IGrid {
  override Getvalue(DataITem: any) {
    if (!this.map.has(DataITem[this.RowIdentifier])) {
      this.DomIDDetails = this.RowIdentifier;
      this.formLines[this.RowIdentifier] = [''];
      this.formLines[this.ChangeSet_Status] = [''];
      let formControl: any = {}
      if (this.map.get(DataITem[this.RowIdentifier])) this.map.get(DataITem[this.RowIdentifier]).DataSource = [];
      this.map.set(DataITem[this.RowIdentifier], { DataSource: this.DataServiceLines[DataITem[this.RowIdentifier]] });
      if (this.DataServiceLines[DataITem[this.RowIdentifier]]?.Columns?.length) {
        this.DataServiceLines[DataITem[this.RowIdentifier]].Columns.forEach((res: any) => formControl[res.Name] = [null]);
      }
      formControl[this.RowIdentifier] = [''];
      formControl[this.ChangeSet_Status] = [''];
      this.ColumnsLines.forEach(res => {
        if (formControl.hasOwnProperty(res.Name)) formControl[res.Name] = [{ value: res.DefaultValue, disabled: !res.IsEditable }, res.Validators];
      })
      this.map.set(DataITem[this.RowIdentifier], { DataSource: this.DataServiceLines[DataITem[this.RowIdentifier]] });

      if (this.ManualParams) {
        this.DataServiceLines[DataITem[this.RowIdentifier]].read();
      }
      else {
        if (this.DataService.Key4) {
          this.DataServiceLines[DataITem[this.RowIdentifier]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
            { Name: [this.DataService.Key3], Operator: 'eq', value: DataITem[this.DataService.Key3], DataType: DataTypes.Text },
            { Name: [this.DataService.Key4], Operator: 'eq', value: DataITem[this.DataService.Key4], DataType: DataTypes.Text },
          ]
        }
        else if (this.DataService.Key3) {
          this.DataServiceLines[DataITem[this.RowIdentifier]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
            { Name: [this.DataService.Key3], Operator: 'eq', value: DataITem[this.DataService.Key3], DataType: DataTypes.Text },
          ]
        }
        else if (this.DataService.Key2) {
          this.DataServiceLines[DataITem[this.RowIdentifier]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
            { Name: [this.DataService.Key2], Operator: 'eq', value: DataITem[this.DataService.Key2], DataType: this.DataTypeKey2 ? this.DataTypeKey2 : DataTypes.Text },
          ]
        }
        else {
          this.DataServiceLines[DataITem[this.RowIdentifier]].Params = [
            { Name: [this.DataService.Key], Operator: 'eq', value: DataITem[this.DataService.Key], DataType: this.DataTypeKey1 ? this.DataTypeKey1 : DataTypes.NUMERIC },
          ]
        }
      }
    }

    return this.map.get(DataITem[this.RowIdentifier]);
  }


  override insertDataItemInRow(args: any) {
    this.dataItem = args.dataItem;
    if (!this.BGridDetailsChildrenGroup[this.dataItem[this.RowIdentifier]]?.formGroups?.length ||
      this.BGridDetailsChildrenGroup[this.dataItem[this.RowIdentifier]]?.formGroups?.every((res: any) => res.status !== "INVALID")) {
      this.CellClick.emit(args);
      this.CurrentSelectRow = this.createFormGroup(args);
      args.sender.editCell(
        args.rowIndex,
        args.columnIndex,
        this.createFormGroup(args)
      );
      this.OverviewDataBindingSubscribtion(this.RowID);
    }
  }

  override BGridDetailsChildren_BeforeAddRow(dataItem: any) {
    setTimeout(() => {
      this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]]?.AllowAdd.next(true);
    })
  }
  override filterInRefrenceChildren(dataItem: any, rowIndex: number) {
    this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]] =
      this.BGridDetailsChildren['_results'].find((res: any) => res["DomID"] === dataItem[this.RowIdentifier]);
    if (
      !this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]] ||
      !this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]]?.formGroups?.filter((res: any) => res.status === "INVALID").length) {
      this.EnableDisableGrid(!this.DisabledLinesGridChild, dataItem);
    }
    return this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]]
  }

  override EnableDisableGrid(IsEditable: boolean, dataItem: any) {
    if (this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]]) {
      if (IsEditable) {
        this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]].Columns.forEach((element: any) => {
          if (element.IsEditable)
            this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]].CurrentSelectRow?.get(element.Name)?.enable({ emitEvent: false });
        });
      } else {
        this.BGridDetailsChildrenGroup[dataItem[this.RowIdentifier]].CurrentSelectRow?.disable({ emitEvent: false });
      }
    }
  }


  public override expandDetailsBy = (dataItem: any): number => {
    return dataItem[this.RowIdentifier];
  };

}
